// Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      window.registration = registration

      registration.addEventListener('updatefound', () => {

        // An updated service worker has appeared in reg.installing!
        let newWorker = registration.installing;

        newWorker.addEventListener('statechange', () => {

          // Has service worker state changed?
          switch (newWorker.state) {
            case 'installed':

	            // There is a new service worker available, show the notification
              if (navigator.serviceWorker.controller) {
                // to-do: update available
              }
              break;
          }
        })
      })

    }).catch(registrationError => {
      // console.log('SW registration failed: ', registrationError);
    });
  });
}
